export const appConfig = {
    GoogleMapsAPIKey: 'AIzaSyCrXL8NJ1hiRi2VlUiHqgNIn3kP1PXq_iU',
    BodygraphApiKey: 'e5271002-05fc-462b-83d2-85720fad15ac',
    ConvertkitApiKey: 'M3V4eaB0uc04rYrmTje5pA',
    externalResourceLink: 'https://realmofbeing.teachable.com/',
    apiUrl: 'https://api.realmofbeing.com/api',
    ConvertKitFormId: '3783630',
    fadeAnimationDuration: 500,
}
